import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Data, START_AB_TEST } from './api'
import { UseStartAbTest } from './types'

export const useStartAbTest = (): UseStartAbTest => {
  const { t } = useTranslation('features/abTests', {
    keyPrefix: 'list.actions.startTest',
  })
  const { enqueueSnackbar } = useSnackbar()

  const [mutate] = useMutation(START_AB_TEST, {
    onCompleted: ({ startAbTest: { errors } }: Data): void => {
      if (errors && errors.length > 0) {
        enqueueSnackbar(errors[0].message, { variant: 'error' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    refetchQueries: ['getAbTests'],
  })

  const startAbTest = (id: string): void => {
    mutate({ variables: { input: { id } } })
  }

  return { startAbTest }
}
